export default __webpack_public_path__ + "static/media/icons8-c++.306831ef.svg";